import MatchedMap from 'utilities/src/matchedMap';

import { ThemeEnum, useTheme } from '../../../../../Theme';

import type { InputThemeProps } from '../../../utils/themes';

/**
 * Import Themes
 */

import inputLabelTopBlogTheme from './_blog';
import inputLabelTopSiteTheme from './_site';

/**
 * Group Themes
 */

const inputLabelTopThemes = (fieldThemeProps: Pick<InputThemeProps, 'inputTheme' | 'inputSize'>) =>
  new MatchedMap([
    [ThemeEnum.Blog, inputLabelTopBlogTheme(fieldThemeProps)],
    [ThemeEnum.Site, inputLabelTopSiteTheme(fieldThemeProps)],
  ]);

/**
 * Theme Hook
 */

const useInputLabelTopTheme = (fieldThemeProps: Pick<InputThemeProps, 'inputTheme' | 'inputSize'>) =>
  useTheme({}, inputLabelTopThemes(fieldThemeProps));

export default useInputLabelTopTheme;
